import gql from 'graphql-tag';

const launchDarklyStatusQuery = gql`
  query getLaunchDarklyStatus($platform: String!) {
    launchDarklyStatus(platform: $platform) {
      enabled
      featureFlags
    }
  }
`;

const getLaunchDarklyStatus = async ({ client, platform }) => {
  const { data } = await client.query({ query: launchDarklyStatusQuery, variables: { platform } });
  return { data };
};

export { getLaunchDarklyStatus };
